import React from 'react';
import { FaWrench, FaBox, FaCar, FaChartBar, FaCreditCard, FaMobileAlt } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaWrench />,
  2: <FaBox />,
  3: <FaCar />,
  4: <FaChartBar />,
  5: <FaCreditCard />,
  6: <FaMobileAlt />
};

const AutomotiveIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="automotive"
      gradient="#1e3a8a 0%, #334155 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default AutomotiveIndustryPage;
